<template>
  <report-section title="心率统计" style="position: relative">
    <template v-slot:content>

      <div class="heart-statistics">
        <data-abstract-unit
          title="平均心率(bpm)"
          :value="model.averagePulse"
        ></data-abstract-unit>
        <data-abstract-unit
          title="最大心率(bpm)"
          :value="model.maxPulse"
        ></data-abstract-unit>
        <data-abstract-unit
          title="最小心率(bpm)"
          :value="model.minPulse"
        ></data-abstract-unit>
      </div>
    </template>
  </report-section>
</template>



<script>

import DataAbstractUnit from "@c/m11b-report-detail/data-abstract/data-abstract-unit.vue";
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
export default {
  components: {
    DataAbstractUnit,
    ReportSection,
  },

  props: {
    model: Object,
  },
};
</script>

<style lang="scss" scoped>

.heart-statistics {
  width: 100%;
  box-sizing: border-box;
  padding: rem(20) rem(20);
  display: flex;
  justify-content: space-between;
}
</style>